import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, DayTimeIntervalDTO, LocationFullDTO, WeeklyScheduleDTO } from '../../../../services/api/api';
import { ActivatedRoute } from '@angular/router';
import { ErrorService } from '../../../../services/error.service';
import { UtilService } from '../../../../services/util.service';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalService } from '../../../../services/gui/modal/modal.service';
import { WeeklyScheduleListComponent } from '../../../datasets/weekly-cycle-list/weekly-schedule-list.component';
import { WeeklyScheduleService } from '../../../../services/date-time/weekly-schedule.service';
import { PermissionService } from '../../../../services/permission.service';

@Component({
  selector: 'app-location-overview',
  templateUrl: './location-overview.component.html',
  styleUrls: ['./location-overview.component.scss'],
  standalone: false,
})
export class LocationOverviewComponent implements OnInit {
  location: LocationFullDTO;

  constructor(
    protected readonly permissionService: PermissionService,
    private api: API,
    private activatedRoute: ActivatedRoute,
    public errorHandler: ErrorService,
    public util: UtilService,
    private destroyRef: DestroyRef,
    private modalService: ModalService,
    public weeklyScheduleService: WeeklyScheduleService
  ) {
    this.location = undefined;
  }

  ngOnInit(): void {
    this.activatedRoute.parent.params.subscribe(params => {
      const locationId = +params.locationID;
      if (locationId) {
        this.api
          .ss_fm_Location_retrieveById(locationId)
          .pipe(takeUntilDestroyed(this.destroyRef), take(1))
          .subscribe({
            next: (e: LocationFullDTO) => {
              this.location = e;
            },
            error: error => {
              this.errorHandler.errorHandler(error);
            },
          });
      }
    });
  }

  getSelectedLocationCoords() {
    if (this.location?.address?.position?.coordinates) {
      return { x: this.location.address.position.coordinates[0], y: this.location.address.position.coordinates[1] };
    }
  }

  selectOpeningHours() {
    this.modalService
      .showNavigationModal({
        entryComponent: { value: WeeklyScheduleListComponent, data: { schedule: this.location.serviceHours } },
        title: null,
        icon: null,
        modalOptions: { size: 'lg' },
      })
      .then((res: WeeklyScheduleDTO) => {
        if (res) {
          this.api.ss_fm_Location_setServiceHoursByDefinition(this.location.id, res.id).subscribe(location => {
            this.location = location;
          });
        }
      })
      .catch(() => {});
  }

  deleteOpeningHours() {
    this.location.serviceHours = null;
    this.api.ss_fm_Location_removeServiceHours(this.location.id).subscribe(() => {});
  }

  getTimeString(hourRange: DayTimeIntervalDTO, rangeType: string): string {
    return ('00' + hourRange[rangeType + 'Hour']).slice(-2) + ':' + ('00' + hourRange[rangeType + 'Minute']).slice(-2);
  }
}
